function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#DEDEDE",
  fillRule: "evenodd",
  d: "M8 0L6.6 1.4 12.2 7H0v2h12.2l-5.6 5.6L8 16l8-8z"
});

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cG9seWdvbiBmaWxsPSIjREVERURFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHBvaW50cz0iMTEyNyAyNzg1IDExMjUuNiAyNzg2LjQgMTEzMS4yIDI3OTIgMTExOSAyNzkyIDExMTkgMjc5NCAxMTMxLjIgMjc5NCAxMTI1LjYgMjc5OS42IDExMjcgMjgwMSAxMTM1IDI3OTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTE5IC0yNzg1KSIvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };